import { IonInput, IonList, IonText } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import moment from 'moment';
import { ReactElement, useState } from 'react';
import { useHistory } from 'react-router';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import { BaseButton } from '../../button/base-button';
import { LoadingButton } from '../../button/loading-button';
import { IonItem } from '../../ionic/IonItem';
import { LoginConfirmProps } from '../login-confirm';
import '../login.css';
import { buildMagicLinkFromSearchParams } from '../login.hooks';
import newMail from '../lottie/new-mail.json';

const WaitingLogin = (props: LoginConfirmProps): ReactElement => {
  const { email, consumeChallengeOnClick, loading, magicLink } = props;

  const [showManualInput, setManualInput] = useState<boolean>(false);
  const history = useHistory();
  const { builder } = useBeaconRouter();

  const onManualConfirm = (url: string) => {
    if (url) {
      const params = new URLSearchParams(url.substring(url.indexOf('?')));
      history.push({
        pathname: builder.getAuthConfirmRoute(),
        search: params.toString(),
      });
    }
  };

  return (
    <>
      <IonList lines="none">
        {email && (
          <IonItem>
            <p>
              {i18n.t('common:login_email_sent')}{' '}
              <IonText color="primary">
                <strong>{email}</strong>
              </IonText>
            </p>
          </IonItem>
        )}
        <IonItem>
          <p>{i18n.t('common:login_confirm_waiting')}</p>
        </IonItem>
        <div>
          <Player
            src={newMail}
            loop={true}
            autoplay={true}
            style={{ height: '200px', width: '200px' }}
          />
        </div>
        {props.expiresIn && (
          <IonItem>
            <p>
              {i18n.t('common:login_link_expires')}
              {moment()
                .add(props.expiresIn, 'milliseconds')
                .format('hh:mm:ss A')}
            </p>
          </IonItem>
        )}
      </IonList>
      <br />
      <div className="ion-padding-horizontal">
        <LoadingButton
          loading={loading}
          buttonProps={{
            type: 'submit',
            disabled: !magicLink.isValid(),
            expand: 'block',
            onClick: consumeChallengeOnClick,
          }}
        >
          {i18n.t('common:next')}
        </LoadingButton>
      </div>
      <div className="secondary-buttons-grid">
        <BaseButton
          className="left manual-input-button"
          buttonProps={{
            fill: 'clear',
            expand: undefined,
            onClick: () => {
              setManualInput(!showManualInput);
            },
          }}
        >
          {i18n.t('common:login_confirm_manually')}
        </BaseButton>
        <BaseButton
          className="right"
          buttonProps={{
            fill: 'clear',
            onClick: () => {
              props.startOverClick();
            },
          }}
        >
          {i18n.t('common:login_start_over')}
        </BaseButton>
      </div>
      <IonItem
        lines={'full'}
        className={
          showManualInput
            ? 'login-confirm-manual-input-show'
            : 'login-confirm-manual-input-hide'
        }
      >
        <IonInput
          disabled={!showManualInput}
          placeholder={i18n.t('common:login_confirm_manually_paste_link')}
          clearOnEdit={true}
          onIonInput={(e) => {
            if (e.detail.value) {
              const params = new URLSearchParams(
                e.detail.value?.substring(e.detail.value.indexOf('?'))
              );
              const link = buildMagicLinkFromSearchParams(params);
              if (link.isValid()) {
                onManualConfirm(e.detail.value);
              }
            }
          }}
        />
      </IonItem>
    </>
  );
};

export { WaitingLogin };
